export default {
  /*
    use this namespace to translate simple and static words
    e.g.
    login: 'Login',
  */
  account: 'Account',
  action: 'Action',
  actions: 'Actions',
  active: 'Active',
  activity_logs: 'Activity Logs',
  actual: 'Actual',
  add: 'Add',
  address: 'Address',
  addresses: 'Addresses',
  adjust: 'Adjust',
  adjustment: 'Adjustment',
  agreement: 'Agreement',
  agreements: 'Agreements',
  allocation: 'Allocation',
  amount: 'Amount',
  assigned: 'Assigned',
  back: 'Back',
  bank: 'Bank',
  bank_account: 'Bank Account',
  bank_branch: 'Bank Branch',
  branch_name: 'Branch Name',
  brand_name: 'Brand Name',
  cancel: 'Cancel',
  capacity: 'Capacity',
  capacity_unit: 'Capacity Unit',
  change: 'Change',
  choose_file: 'Choose File',
  city: 'City',
  colors: {
    black: 'Black',
    yellow: 'Yellow',
    white: 'White',
  },
  close: 'Close',
  confirm: 'Confirm',
  continue: 'Continue',
  copied: 'Copied',
  contact: 'Contact',
  contract: 'Contract',
  contracts: 'Contracts',
  daily: 'Daily',
  date: 'Date',
  dedicated: 'Dedicated',
  delete: 'Delete',
  delivery_order: 'Delivery Order',
  delivery_orders: 'Delivery Orders',
  description: 'Description',
  destination: 'Destination',
  details: 'Details',
  dimension: 'Dimension',
  dispatch: 'Dispatch',
  do: 'DO',
  doc: 'Doc',
  document: 'Document',
  documents: 'Documents',
  done: 'Done',
  download: 'Download',
  download_documents: 'Download Documents',
  download_failed_data_csv: 'Download Failed Data CSV',
  download_pdf: 'Download PDF',
  download_selected_data: 'Download Selected Data',
  download_template: 'Download Template',
  driver: 'Driver',
  drivers: 'Drivers',
  drop_point: 'Drop Point',
  duplicate: 'Duplicate',
  edit: 'Edit',
  email: 'Email',
  end_date: 'End Date',
  entity: 'Entity',
  expected: 'Expected',
  expiration_date_if_any: 'Expiration Date (if any)',
  expired_soon: 'Expired Soon',
  false: 'False',
  file: 'File',
  file_is_empty: 'File is empty',
  files: 'Files',
  filter: 'Filter',
  finish: 'Finish',
  flat: 'Flat',
  fleet: 'Fleet',
  fleets: 'Fleets',
  from: 'from',
  full_address: 'Full Address',
  helper: 'Helper',
  hide: 'Hide',
  id: 'ID',
  inactive: 'Inactive',
  invoices: 'Invoices',
  latitude: 'Latitude',
  leave_page: 'Leave Page',
  license_plate: 'License Plate',
  location: 'Location',
  locations: 'Locations',
  longitude: 'Longitude',
  map: 'Map',
  monitoring: 'Monitoring',
  monthly: 'Monthly',
  name: 'Name',
  need_revision: 'Need Revision',
  next: 'Next',
  no: 'No',
  notes: 'Notes',
  not_found: 'Not Found',
  not_submitted: 'Not Submitted',
  not_uploaded: 'Not Uploaded',
  optional: 'Optional',
  oncall: 'On Call',
  payables: 'Payables',
  payment_request: 'Payment Request',
  pdf: 'PDF',
  pending: 'Pending',
  percentage: 'Percentage',
  personal_account: 'Personal Account',
  phone: 'Phone',
  phone_number: 'Phone Number',
  pipeline: 'Pipeline',
  price: 'Price',
  project: 'Project',
  projects: 'Projects',
  province: 'Province',
  reason: 'Reason',
  reassigned: 'Reassigned',
  remove: 'Remove',
  revise: 'Revise',
  receivables: 'Receivables',
  route: 'Route',
  routing: 'Routing',
  save: 'Save',
  saved: 'Saved',
  share: 'Share',
  shipments: 'Shipments',
  shipper: 'Shipper',
  shippers: 'Shippers',
  show: 'Show',
  start_date: 'Start Date',
  status: 'Status',
  submit: 'Submit',
  summary: 'Summary',
  supply: 'Supply',
  tags: 'Tags',
  tax: 'Tax',
  total: 'Total',
  transporter: 'Transporter',
  transporters: 'Transporters',
  true: 'True',
  type: 'Type',
  update: 'Update',
  updated: 'Updated',
  updated_at: 'Updated At',
  upload: 'Upload',
  upload_csv: 'Upload CSV',
  upload_result: 'Upload Result',
  uploading: 'Uploading',
  uploaded: 'Uploaded',
  view: 'View',
  view_log: 'View Log',
  yes: 'Yes',
};
